import { render } from "./Hospitals.vue?vue&type=template&id=f16b9542&scoped=true&lang=pug"
import script from "./Hospitals.vue?vue&type=script&lang=js"
export * from "./Hospitals.vue?vue&type=script&lang=js"

import "./Hospitals.vue?vue&type=style&index=0&id=f16b9542&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f16b9542"]])

export default __exports__